import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const PinLocationOutlineIcon = (props) => (
  <SvgIcon viewBox="0 0 20 20" {...props}>
    <path
      d="M4.66602 7.49935C4.66602 4.55382 7.05382 2.16602 9.99935 2.16602C12.9449 2.16602 15.3327 4.55382 15.3327 7.49935C15.3327 9.00515 14.4816 10.9486 13.3778 12.8098C12.2881 14.6474 11.0078 16.3148 10.2558 17.2439C10.1225 17.4084 9.87615 17.4084 9.74293 17.2439C8.99092 16.3148 7.71063 14.6474 6.62087 12.8098C5.51714 10.9486 4.66602 9.00515 4.66602 7.49935Z"
      fill="transparent"
      stroke={props.sx?.iconStrokeColor || props.sx?.color || '#080F1D'}
    />
    <path
      d="M11.5 8C11.5 8.82843 10.8284 9.5 10 9.5C9.17157 9.5 8.5 8.82843 8.5 8C8.5 7.17157 9.17157 6.5 10 6.5C10.8284 6.5 11.5 7.17157 11.5 8Z"
      fill={props.sx?.color || '#080F1D'}
      stroke={props.sx?.iconStrokeColor || props.sx?.color || '#080F1D'}
    />
  </SvgIcon>
);

PinLocationOutlineIcon.propTypes = {
  sx: PropTypes.object,
};

export default PinLocationOutlineIcon;
